// Resolves external CMS links (news, downloads, AGB, Datenschutz) for either
// the new Shopify storefront (default) or the legacy Neos site, so iframe
// embeds served from both can keep the right URLs while content migrates.
//
// Selection:
//   1. window.CUSTOMERAREA_CMS (set by public/index.html from ?cms=)
//   2. ?cms=<key> on the iframe URL (fallback for embeds that don't bootstrap
//      from index.html, e.g. webservice-meet)
//   3. default 'shopify'
//
// Add new entries here rather than scattering URLs across components. When a
// page migrates from Neos to Shopify, flip only its `shopify` entry.

const CMS_PAGES = {
  neos: {
    news: 'https://www.maluwilz.de/de/0e200842-ae1b-11e9-a2a3-2a2ae2dbcce4.html',
    download: 'https://www.maluwilz.de/de/0e2005e0-ae1b-11e9-a2a3-2a2ae2dbcce4.html',
    agb: 'https://www.maluwilz.de/de/agb.html',
    datenschutz: 'https://www.maluwilz.de/de/datenschutz.html'
  },
  shopify: {
    news: 'https://www.maluwilz.de/de-de/pages/handler-news',
    download: 'https://www.maluwilz.de/de-de/pages/download-bereich',
    agb: 'https://www.maluwilz.de/de-de/pages/agb-b2b',
    datenschutz: 'https://www.maluwilz.de/de-de/policies/privacy-policy'
  }
}

export function getCms () {
  if (typeof window === 'undefined') return 'shopify'
  if (window.CUSTOMERAREA_CMS) return window.CUSTOMERAREA_CMS
  try {
    const fromQuery = new URLSearchParams(window.location.search).get('cms')
    if (fromQuery) return fromQuery
  } catch (e) { /* no-op */ }
  return 'shopify'
}

export function cmsPage (key) {
  const cms = getCms()
  return (CMS_PAGES[cms] || CMS_PAGES.shopify)[key]
}
